// @flow
import { fetchFeed } from '../feedActionsCreator/general';
import { fetch } from '../../api';

export function formatData(payload: any) {
  const { groups, posts, users, hits } = payload;

  const postDataById = {};
  posts.forEach(p => postDataById[p.id] = p);
  const fullPosts = hits.hits.map(p => {
    const post = {
      ...p._source,
      ...postDataById[p._source.id],
    };
    return {
      ...post,
      totalResponses: post.responses,
    };
  });

  return { data: { groups, posts: fullPosts, users } };
}

type Filter = { query: string, groupId: IdType, groupCode: IdType };
export async function fetchPosts(start: number, filter: Filter): Object {
  const query = {
    start,
    limit: start + 20,
    sortDate: false,
    query: filter.query,
    groupCode: filter.groupCode,
    groupId: filter.groupId,
  };
  const { payload } = await fetch('sitesearch', { query });

  return formatData(payload);
}

export function customFetch(start: number, filter: Filter) {
  return () => fetchPosts(start, filter);
}

export function searchPosts(id: String, start: number, filter: Filter) {
  const feed = { id, dataType: 'posts', filter };

  // return fetchFeed(feed, false, fetchGroups({ key: searchText, ...query }));
  return fetchFeed(feed, start === 0, customFetch(start, filter));
}



// WEBPACK FOOTER //
// ./~/virgo/src/actions/searchActionsCreator/searchPostsActionsCreator.js